var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { DataTypeOperator } from "../../../models/audience/filter.model";
import FilterResourceIdInput from "./FilterResourceIdInput";
import FilterProfileIdInput from "./FilterProfileIdInput";
import FilterSectorIdInput from "./FilterSectorIdInput";
import FilterServiceIdInput from "./FilterServiceIdInput";
import { useTranslation } from "react-i18next";
import FilterSourceConfigInput from "./FilterSourceConfigsInput";
import FilterCountryInput from "./FilterCountryInput";
import FilterLanguageInput from "./FilterLanguageInput";
import FilterMetaCampaignIdInput from "./FilterMetaCampaignIdInput";
import FilterCategoryIdInput from "./FilterCategoryIdInput";
import FilterServiceCategoryIdInput from "./FilterServiceCategoryIdInput";
import FilterUserIdInput from "./FilterUserIdInput";
import CountryLanguagePicker from "../../inputs/CountryLanguagePicker";
export var FilterTextInput = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var operator = _a.operator, filterRow = _a.filterRow, setFilterRow = _a.setFilterRow, idType = _a.idType, forceSectorId = _a.forceSectorId;
    var t = useTranslation().t;
    var isIdField = !!idType;
    var content = null;
    switch (operator) {
        case DataTypeOperator.EQUAL:
        case DataTypeOperator.NOT_EQUAL:
        case DataTypeOperator.CONTAINS:
        case DataTypeOperator.DOES_NOT_CONTAIN:
        case DataTypeOperator.SIMILAR_TO:
        case DataTypeOperator.STARTS_WITH:
        case DataTypeOperator.ENDS_WITH:
            if (idType === 'language_code_iso_639_1' || idType === 'country_code_iso_3166_alpha_2') {
                content = _jsx(CountryLanguagePicker, { kind: idType === 'language_code_iso_639_1' ? 'language' : 'country', label: ((_b = filterRow.field) === null || _b === void 0 ? void 0 : _b.split('.').pop()) === 'nationality' ? t('Nationality') : undefined, value: (_d = (_c = filterRow.textValues) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : '', onChange: function (value) { return setFilterRow(__assign(__assign({}, filterRow), { textValues: [value] })); } });
                break;
            }
            content = (_jsx(TextField, { size: 'small', autoFocus: true, hiddenLabel: true, variant: 'outlined', type: 'text', value: (_e = filterRow.textValues) === null || _e === void 0 ? void 0 : _e[0], onChange: function (e) {
                    setFilterRow(__assign(__assign({}, filterRow), { textValues: [e.target.value] }));
                }, sx: { width: '100%', minWidth: 200 } }));
            break;
        case DataTypeOperator.IN:
        case DataTypeOperator.NOT_IN:
            if (isIdField) {
                switch (idType) {
                    case "resource":
                        content = (_jsx(FilterResourceIdInput, { ids: (((_f = filterRow.textValues) === null || _f === void 0 ? void 0 : _f.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            }, forceSectorId: forceSectorId }));
                        break;
                    case "category":
                        content = (_jsx(FilterCategoryIdInput, { ids: (((_g = filterRow.textValues) === null || _g === void 0 ? void 0 : _g.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            }, forceSectorId: forceSectorId }));
                        break;
                    case "service_category":
                        content = (_jsx(FilterServiceCategoryIdInput, { ids: (((_h = filterRow.textValues) === null || _h === void 0 ? void 0 : _h.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            }, forceSectorId: forceSectorId }));
                        break;
                    case "profile":
                        content = (_jsx(FilterProfileIdInput, { ids: (((_j = filterRow.textValues) === null || _j === void 0 ? void 0 : _j.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            } }));
                        break;
                    case "user":
                        content = (_jsx(FilterUserIdInput, { ids: (((_k = filterRow.textValues) === null || _k === void 0 ? void 0 : _k.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            } }));
                        break;
                    case "sector":
                        content = (_jsx(FilterSectorIdInput, { ids: (((_l = filterRow.textValues) === null || _l === void 0 ? void 0 : _l.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            } }));
                        break;
                    case "service":
                        content = (_jsx(FilterServiceIdInput, { ids: (((_m = filterRow.textValues) === null || _m === void 0 ? void 0 : _m.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            }, forceSectorId: forceSectorId }));
                        break;
                    case "integration_config":
                        content = (_jsx(FilterSourceConfigInput, { ids: (((_o = filterRow.textValues) === null || _o === void 0 ? void 0 : _o.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            } }));
                        break;
                    case "country_code_iso_3166_alpha_2":
                        content = (_jsx(FilterCountryInput, { label: ((_p = filterRow.field) === null || _p === void 0 ? void 0 : _p.split('.').pop()) === 'nationality' ? t('Nationality') : undefined, ids: (((_q = filterRow.textValues) === null || _q === void 0 ? void 0 : _q.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            } }));
                        break;
                    case "campaign":
                        content = (_jsx(FilterMetaCampaignIdInput, { ids: (((_r = filterRow.textValues) === null || _r === void 0 ? void 0 : _r.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            } }));
                        break;
                    case "language_code_iso_639_1":
                        content = (_jsx(FilterLanguageInput, { ids: (((_s = filterRow.textValues) === null || _s === void 0 ? void 0 : _s.filter(Boolean)) || []), setIds: function (ids) {
                                setFilterRow(__assign(__assign({}, filterRow), { textValues: ids }));
                            } }));
                }
            }
            else {
                content = (_jsx(Autocomplete, { size: 'small', clearIcon: false, options: [], freeSolo: true, multiple: true, renderTags: function (value, props) {
                        return value.map(function (option, index) { return (_jsx(Chip, __assign({ size: 'small', label: option }, props({ index: index })))); });
                    }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { placeholder: t("Add Values"), hiddenLabel: true })); }, sx: { width: '100%', minWidth: 200 }, value: ((_t = filterRow.textValues) === null || _t === void 0 ? void 0 : _t.filter(function (v) { return !!v; })) || [], onChange: function (e, value) {
                        setFilterRow(__assign(__assign({}, filterRow), { textValues: value }));
                    } }));
            }
    }
    return content;
};
